__turbopack_context__.v({
  "pill": "_3E1BAW_pill",
  "pillList": "_3E1BAW_pillList",
  "scrollableContainer": "_3E1BAW_scrollableContainer",
});
